import StyledLink from '../StyledLink'
import {
  CUSTOM_SCRIPT,
  SYSTEM
} from '../routes'
import type { Props } from '../types'

const LinkToCustomScript = ({
  children,
  isHyperlink,
  label,
  openInNewTab,
  isInlineLink = false
}: Props) =>
  <StyledLink
    aria-label={label}
    isHyperlink={isHyperlink}
    isInlineLink={isInlineLink}
    openInNewTab={openInNewTab}
    to={'/' + SYSTEM + '/' + CUSTOM_SCRIPT}
  >
    {children}
  </StyledLink>

export default LinkToCustomScript
